import { ComponentProps } from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export type AvailableSections =
  | 'basic'
  | 'review_types'
  | 'timeline'
  | 'visibility'
  | 'features'
  | 'target'
  | 'target_group'
  | 'questions_view'
  | 'scoring_system'

type SettingSection = {
  label: string
  value: AvailableSections
  icon: ComponentProps<typeof Icon.Medium>['icon']
}
export const settingsSections: (hideSections?: AvailableSections[]) => SettingSection[] = (
  hideSections = []
) => {
  const sections: SettingSection[] = [
    {
      label: i18n.t('performance_process.reviews.basic_information'),
      icon: 'file-filled',
      value: 'basic',
    },
    {
      label: i18n.t('performance_process.reviews.review_types'),
      icon: 'list',
      value: 'review_types',
    },
    {
      label: i18n.t('performance_process.reviews.targets'),
      icon: 'manager',
      value: 'target',
    },
    {
      label: i18n.t('performance_process.reviews.scoring_system.title'),
      icon: 'numbers',
      value: 'scoring_system',
    },
    {
      label: i18n.t('performance_process.reviews.features.title'),
      icon: 'laptop',
      value: 'features',
    },
    {
      label: i18n.t('performance_process.reviews.timeline'),
      icon: 'calendar',
      value: 'timeline',
    },
    {
      label: i18n.t('performance_process.reviews.visibility'),
      icon: 'eye-visible',
      value: 'visibility',
    },
    {
      label: i18n.t('performance_process.reviews.target_title'),
      icon: 'manager',
      value: 'target_group',
    },
    {
      label: i18n.t('performance_process.reviews.questions'),
      icon: 'question-circle-line',
      value: 'questions_view',
    },
  ]

  return hideSections.length
    ? sections.filter((section) => !hideSections.includes(section.value))
    : sections
}

export function sectionSearchParam(section: AvailableSections) {
  return `?section=${section}`
}
